/**
 * @desc 申请物流
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/test/testApplyLogisitcs`, {
      method: "POST",

      ...options,
    }),
  );
}
